<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Enrollment</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <div class="mr-2">
              <enrollment-modal @created="handleCreated"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <enrollment-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>

  </div>
</template>

<script>
import enrollmentModal from '@/components/hostel/manage/hostel-enrollment/add'
import enrollmentTable from '@/components/hostel/manage/hostel-enrollment/index'
export default {
  components: {
    enrollmentModal,
    enrollmentTable,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('hostel-enrollment', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  mounted() {
    this.getBlocks()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getBlocks: function() {
      this.selectedRowKeys = []
      this.loading = true
      this.$http.get('/api/hostel/enrollment/all', {
        params: {
          limit: this.pageSize,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getBlocks()
    },
    onChange(current) {
      this.current = current
      this.getBlocks()
    },
    handleUpdateTable: function() {
      this.getBlocks()
    },
    handleCreated: function() {
      this.getBlocks()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
